import FilesCommentsManage from "./files-comments-manage";

export default FilesCommentsManage;
